import React, { useEffect, useRef } from 'react'
import { Button } from 'mailup-web-components'
import { useIntl } from 'react-intl'
import BoxProgress from './BoxProgress'
import BoxCredits from './BoxCredits'
import BoxSheduling from './BoxSheduling'
import { useRecoilCallback, useRecoilValue } from 'recoil'
import { progressState, scheduledSendingState } from '../recoil/states/state'
import { RCS_QUEUING_RUNNING } from 'Api/beRcs'
import {
  checkProgressCallback,
  createSendingQueueCallback,
  sendMessageCallback
} from '../recoil/callbacks/callbacks'
import {
  useHistory,
  useParams
} from 'react-router-dom/cjs/react-router-dom.min'
import {
  pageState,
  sendNowDisableState,
  sendScheduledDisableState
} from '../recoil/states/page'
import styled from '@emotion/styled'

const StyledBackButton = styled(Button)`
  float: left !important;
`

const WizardStep2 = () => {
  const intl = useIntl()
  const history = useHistory()
  const { isScheduledSending } = useRecoilValue(scheduledSendingState)
  const { queueStatus } = useRecoilValue(progressState)
  const { idQueuing, backToStep1Disable } = useRecoilValue(pageState)
  const sendNowDisable = useRecoilValue(sendNowDisableState)
  const sendScheduledDisable = useRecoilValue(sendScheduledDisableState)
  const createSendingQueue = useRecoilCallback(createSendingQueueCallback, [])
  const checkProgress = useRecoilCallback(checkProgressCallback, [])
  const { idMessage, idBot } = useParams()
  const timer = useRef(true)
  const sendMessage = useRecoilCallback(sendMessageCallback, [])

  useEffect(() => {
    createSendingQueue(idBot, idMessage)
  }, [])

  useEffect(() => {
    if (idQueuing && queueStatus === RCS_QUEUING_RUNNING) {
      timer.current = setInterval(() => checkProgress(), 1000)
      return () => clearInterval(timer.current)
    }
  }, [idQueuing, queueStatus])

  const send = async val => {
    if (val === 'SendLater') {
      history.push('/messages/rcs/sendstatus')
    } else {
      const ret = await sendMessage()
      if (ret) {
        history.push('/messages/rcs/sendstatus')
      }
    }
  }

  return (
    <>
      <BoxProgress />
      <BoxCredits />
      <BoxSheduling />
      <StyledBackButton
        kind='secondary'
        disabled={backToStep1Disable}
        data-mu-test='button-back-step-2'
      >
        {intl.formatMessage({
          id: 'Load.Common.Backwards'
        })}
      </StyledBackButton>
      {isScheduledSending && (
        <Button
          kind='primary'
          disabled={sendScheduledDisable}
          onClick={() => send('Schedule')}
          data-mu-test='button-Schedule'
        >
          {intl.formatMessage({
            id: 'Load.Rcs.Schedule'
          })}
        </Button>
      )}
      {!isScheduledSending && (
        <Button
          kind='primary'
          disabled={sendNowDisable}
          onClick={() => send('SendNow')}
          data-mu-test='button-SendNow'
        >
          {intl.formatMessage({
            id: 'Load.Rcs.SendNow'
          })}
        </Button>
      )}
      <Button
        kind='secondary'
        disabled={sendScheduledDisable}
        onClick={() => send('SendLater')}
        data-mu-test='button-SendLater'
      >
        {intl.formatMessage({
          id: 'Load.Rcs.SendLater'
        })}
      </Button>
    </>
  )
}

export default WizardStep2
